
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { BootController } from './boot-control';

if (environment.production) {
    enableProdMode();
}

const init = () => {
    platformBrowserDynamic().bootstrapModule(AppModule)
        .catch(err => { });
}

init();

const boot = BootController.getbootControl().watchReboot().subscribe(() => init());

